import React from 'react'
import walletimg from "../../../assets/images/wallet.png"
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "antd";
import {PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";


const walleytBalance = () => {
  return (
    <div className="document-upload wallet-credits-wrap ">
      <div className="title">Credits</div>

        <Row>
          <Col lg={12}>
                <div className="wallet-balance-wrap">
                  <img src={walletimg} alt="wallteimg" />
                  <div className='balance-head'>Your Wallet Credits Balance</div>
                  <div className="wallet-price">₹360</div>
                  <p className="balance-details">The balance can be applied only with net banking or credit/debit cards</p>
                </div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
              <div className="add-money-btn-wrap">
              <Link to="/addmoney">
                <Button type='primary ' className='money-btn'>
                <PlusOutlined className='wallet-icon' />
                  Add Money
                </Button>
                </Link>
              </div>
          </Col>
        </Row>
    </div>
  )
}

export default walleytBalance